import dayjs from '@core/lib/dayjs';

export const fmtCampaignDate = (date) =>
  date ? dayjs(date).format('MMM DD, YYYY') : '-';

export const getCampaignDates = (campaign) => [
  dayjs(campaign.startAt),
  dayjs(campaign.endAt),
];
